module.exports = __webpack_public_path__ + "img/avatar.cfc671a8.jpeg";